<template>
  <li class="menu-item" :class="{ active }">
    <RouterLink :to="to">
      <span class="label">{{ $t(label) }}</span>
    </RouterLink>
  </li>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue"
import type { RouteLocationRaw } from "vue-router"

export default defineComponent({
  name: "NavMenuItem",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      required: true,
    },
  },
})
</script>
<style scoped lang="scss">
.menu-item {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  font-family: Montserrat;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  text-align: center;
  color: #ffffff;

  &.active,
  &:hover {
    &::before,
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 4px;
      background: var(--text-gradient-5);
      border-radius: 8px;
      transform: rotate(180deg);
    }

    &::after {
      filter: blur(4px);
    }
  }

  &.active,
  &:hover {
    ::v-deep(svg) {
      path {
        fill: url(#gradient);
      }
    }
    .label {
      background: var(--text-gradient-165);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>
